import { DateFormat, getFormatDate, utcToIST } from 'src/utils/DateHelper';
import styles from './index.module.scss';
import { ameyoNonConnectedOptionStyles } from './utils';
import cx from 'classnames';
import {
  AmeyoNonConnectedDispositionProps,
  AmeyoNonConnectedDispositionsComponentProps
} from './type';
import DateTime from '../DateTime';

const AmeyoNonConnectedDispositions = ({
  ameyoNonConnectedInteractionsInfo,
  recipientNumber
}: AmeyoNonConnectedDispositionsComponentProps) => {
  return (
    ameyoNonConnectedInteractionsInfo?.length > 1 &&
    ameyoNonConnectedInteractionsInfo
      .slice(1)
      .map((AmeyoNonConnectedDisposition: AmeyoNonConnectedDispositionProps) => {
        const istDate = utcToIST(AmeyoNonConnectedDisposition.createdAt as unknown as Date);
        return (
          <div
            className={styles.ameyoNonConnectedDispositionsWrapper}
            key={AmeyoNonConnectedDisposition?.createdAt}
          >
            <div className={cx(styles.textColor, styles.formatDate)}>
              <DateTime istDate={istDate} />
            </div>
            <div className={cx(styles.textColor, styles.recipientNumber)}>{recipientNumber}</div>
            <div className={styles.callStatusView}>
              <div
                className={cx(
                  ameyoNonConnectedOptionStyles(AmeyoNonConnectedDisposition?.interactionLevel)
                )}
              >
                {AmeyoNonConnectedDisposition?.callStatusView}
              </div>
            </div>
            <div className={cx(styles.textColor, styles.type)}>Ameyo</div>
            <div className={styles.textColor}>No Recording</div>
          </div>
        );
      })
  );
};

export default AmeyoNonConnectedDispositions;
